import React from "react"

import { ProjectChild } from "shared/types/Project"

import { ProjectPageSidebarFactory } from "pages/project-page/sidebar/ProjectPageSidebarFactory"

import { SharedProjectPageFloorSidebarConnector } from "./SharedProjectPageFloorSidebarConnector"
import { SharedProjectPageProductPositionMultiSelectSidebarConnector } from "./SharedProjectPageProductPositionMultiSelectSidebarConnector"
import { SharedProjectPageProductPositionSidebarConnector } from "./SharedProjectPageProductPositionSidebarConnector"
import { SharedProjectPageProjectChildMultiSelectSidebarConnector } from "./SharedProjectPageProjectChildMultiSelectSidebarConnector"
import { SharedProjectPageProjectSidebarConnector } from "./SharedProjectPageProjectSidebarConnector"
import { SharedProjectPageRoomMultiSelectSidebarConnector } from "./SharedProjectPageRoomMultiSelectSidebarConnector"
import { SharedProjectPageRoomSidebarConnector } from "./SharedProjectPageRoomSidebarConnector"

interface SharedProjectPageSidebarProps {
  projectID: string
  selectedChildren: ProjectChild[]
}

export const SharedProjectPageSidebar = React.memo(
  (props: SharedProjectPageSidebarProps) => (
    <ProjectPageSidebarFactory
      {...props}
      components={{
        ProjectSidebar: SharedProjectPageProjectSidebarConnector,
        FloorSidebar: SharedProjectPageFloorSidebarConnector,
        ProductPositionSidebar:
          SharedProjectPageProductPositionSidebarConnector,
        ProductPositionMultiSelectSidebar:
          SharedProjectPageProductPositionMultiSelectSidebarConnector,
        RoomSidebar: SharedProjectPageRoomSidebarConnector,
        RoomMultiSelectSidebar:
          SharedProjectPageRoomMultiSelectSidebarConnector,
        ProjectChildMultiSelect:
          SharedProjectPageProjectChildMultiSelectSidebarConnector
      }}
    />
  )
)
